export const WELD_BIGQUERY_ID = "weld-bigquery";

export const HUBSPOT_PORTAL_ID = "14524888";
export const HUBSPOT_USER_FORM_GUID = "76c04f2c-866c-49ba-be19-b1e935e5b0b3";
